<script>
  import Chartline from "./ChartDefaultMD.svelte";
  import ToolsSpinner from "../ihm/ToolsSpinner.svelte";
  import { onMount } from "svelte";
  import { urlServeur } from "../conf";

  let promiseAll;
  let axeTxfAll;
  let serieTxfAll;
  let axeTxfPerso;
  let serieTxfPerso;

  const fecthDataAll = async () => {
    const response = await fetch(urlServeur + "/api/immeubles/graphDepPerso");
    const result = await response.json();

    axeTxfAll = result.payload.axe_depenses;
    axeTxfAll = axeTxfAll.slice(1, -1).split(","); // supprimer les [], et convertie chaine en tableau
    serieTxfAll = JSON.parse(result.payload.serie_depenses);
  };

  onMount(async () => {
    promiseAll = fecthDataAll();
  });
</script>

<div class="chart-container">
  <div class="pie-chart-container">
    {#await promiseAll}
      <ToolsSpinner />
    {:then number}
      <h3>Ttes Tx. F</h3>
      <Chartline
        chartType={"line"}
        chartDatasets={serieTxfAll}
        chartDataLabels={axeTxfAll}
        chartLabelLine={"Ttes Tx. F"}
      />
    {/await}
  </div>
</div>

<style>
  .chart-container {
    align: "center";
  }

  .pie-chart-container {
    height: 360px;
    width: 360px;
    float: left;
  }
</style>
